module.exports = __webpack_public_path__ + "static/media/non_member_sample_basket_01.98d65c54.jpg";